/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./uploader-list-dialog.vue?vue&type=template&id=923da6fa&scoped=true&"
import script from "./uploader-list-dialog.vue?vue&type=script&lang=ts&"
export * from "./uploader-list-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./uploader-list-dialog.vue?vue&type=style&index=0&id=923da6fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923da6fa",
  null
  
)

export default component.exports